import { Component, OnInit } from '@angular/core';
import { AdminToursService } from '../shared/service/admin-tours.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PagerService } from '../shared/service/pager.service';
import { Router, NavigationExtras, ActivatedRoute, Params } from '@angular/router';
import { AdminDestinationService } from '../shared/service/admin-destination.service';
import { environment } from 'src/environments/environment';
import { ContentObserver } from '@angular/cdk/observers';
declare var $: any;
const SEARCH_TOUR_TYPE = 'searchTourType';

@Component({
  selector: 'app-all-tours',
  templateUrl: './all-tours.component.html',
  styleUrls: ['./all-tours.component.css']
})
export class AllToursComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  tourId: number;
  tours: string;
  imagePath: string;
  public href: string = "";
  searchTourObj: any = {}
  paramTours: any = {}
  toursArr = [];
  destinationArr = [];
  filteredResult = [];
  pager: any = {};
  search: string;
  pagedItems: any[] = [];
  imageBaseUrl: string = environment.imageBaseUrl;
  serviceBaseUrl:string = environment.serviceBaseUrl;
  isResult: boolean = true;

  constructor(private adminToursService: AdminToursService, private pagerService: PagerService, private router: Router, private route: ActivatedRoute, private adminDestinationService: AdminDestinationService) {
    this.route.params.subscribe((params) => {
      this.tours = params.tours;
      if (this.tours) {
        if (localStorage.getItem(SEARCH_TOUR_TYPE) == 'true') {
          this.searchTourObj.TourSubType = this.tours;
        }
        else {
          this.searchTourObj.TourName = this.tours;
        }
        this.searchTour();
        localStorage.setItem(SEARCH_TOUR_TYPE, "false");
      }
    });
    this.route.queryParams.subscribe((params) => {
      if (params["TourName"]) {
        this.paramTours.TourName = params["TourName"];
      }
      if (params["TourType"]) {
        this.paramTours.TourType = params["TourType"];
      }
      if (params["Destinations"]) {
        this.paramTours.Destinations = params["Destinations"];
      }
      if (params["TourSubType"]) {
        this.paramTours.TourSubType = params["TourSubType"];
      }
      this.getToursDetails();
    })
  }

  ngOnInit() {
    this.imagePath = this.imageBaseUrl + "/tours-img/KesaviDefault.jpg";
    this.getDestination();
  }

  getToursDetails() {
    this.isResult = true;
    this.blockUI.start("Please Wait....");
    this.adminToursService
      .getTours()
      .then((result) => {
        this.toursArr = [];
        if (this.paramTours.TourName == null && this.paramTours.TourType == null && this.paramTours.Destinations == null && this.paramTours.TourSubType == null) {
          this.toursArr = result;
        }
        else {
          for (let i = 0; i < result.length; i++) {
            if (this.paramTours.TourName != null && this.paramTours.TourType != null && this.paramTours.Destinations != null && this.paramTours.TourSubType != null) {
              if (result[i].TourName.indexOf(this.paramTours.TourName) != -1 && result[i].TourType == this.paramTours.TourType && result[i].TourSubType == this.paramTours.TourSubType && result[i].Destinations.indexOf(this.paramTours.Destinations) != -1)
                this.toursArr.push(result[i]);
            }
            else if (this.paramTours.TourName != null && result[i].TourName.indexOf(this.paramTours.TourName) != -1 && this.paramTours.TourType != null && result[i].TourType == this.paramTours.TourType) {
              this.toursArr.push(result[i]);
            }
            else if (this.paramTours.TourName != null && result[i].TourName.indexOf(this.paramTours.TourName) != -1 && this.paramTours.Destinations != null && result[i].Destinations.indexOf(this.paramTours.Destinations) != -1) {
              this.toursArr.push(result[i]);
            }
            else if (this.paramTours.TourName != null && result[i].TourName.indexOf(this.paramTours.TourName) != -1 && this.paramTours.TourSubType != null && result[i].TourSubType.indexOf(this.paramTours.TourSubType) != -1) {
              this.toursArr.push(result[i]);
            }
            else if (this.paramTours.TourType != null && result[i].TourType == this.paramTours.TourType && this.paramTours.Destinations != null && result[i].Destinations.indexOf(this.paramTours.Destinations) != -1) {
              this.toursArr.push(result[i]);
            }
            else if (this.paramTours.TourType != null && result[i].TourType == this.paramTours.TourType && this.paramTours.TourSubType != null && result[i].TourSubType.indexOf(this.paramTours.TourSubType) != -1) {
              this.toursArr.push(result[i]);
            }
            else if (this.paramTours.Destinations != null && result[i].Destinations == this.paramTours.Destinations && this.paramTours.TourSubType != null && result[i].TourSubType.indexOf(this.paramTours.TourSubType) != -1) {
              this.toursArr.push(result[i]);
            }
            //else if ((this.paramTours.TourName == null && this.paramTours.Destinations == null) || (this.paramTours.TourType == null && this.paramTours.Destinations == null) || (this.paramTours.TourType == null && this.paramTours.TourName == null) || (this.paramTours.TourSubType == null && this.paramTours.TourName == null) || (this.paramTours.TourSubType == null && this.paramTours.TourType == null) || (this.paramTours.TourSubType == null && this.paramTours.Destinations == null)) {
            else if ((this.paramTours.TourName == null && this.paramTours.Destinations == null && this.paramTours.TourSubType == null) || (this.paramTours.TourType == null && this.paramTours.Destinations == null && this.paramTours.TourSubType == null) || (this.paramTours.TourType == null && this.paramTours.TourName == null && this.paramTours.TourSubType == null) || (this.paramTours.TourType == null && this.paramTours.TourName == null && this.paramTours.Destinations == null)) {
              if (this.paramTours.TourName != null && result[i].TourName.indexOf(this.paramTours.TourName) != -1) {
                this.toursArr.push(result[i]);
              }
              else if (this.paramTours.TourType != null && result[i].TourType.indexOf(this.paramTours.TourType) != -1) {
                this.toursArr.push(result[i]);
              }
              else if (this.paramTours.Destinations != null && result[i].Destinations.indexOf(this.paramTours.Destinations) != -1) {
                this.toursArr.push(result[i]);
              }
              else if (this.paramTours.TourSubType != null && result[i].TourSubType.indexOf(this.paramTours.TourSubType) != -1) {
                this.toursArr.push(result[i]);
              }
            }
          }
        }
        this.setPage(1);
      })
      .catch((err) => this.errorHandler(err));
  }

  getDestination() {
    this.adminDestinationService
      .getDestination()
      .then((result) => { this.destinationArr = result; })
      .catch((err) => { console.log(err); });
  }

  setPage(page: number) {
    // get pager object from service
    this.pager = this.pagerService.getPager(this.toursArr.length, page);
    if(this.toursArr.length == 0){
      this.isResult = false;
    }
    // else{
    //   this.isResult = true;
    // }
    
    // get current page of items
    this.pagedItems = this.toursArr.slice(this.pager.startIndex, this.pager.endIndex + 1);

    if(this.blockUI){
      this.blockUI.stop();
    }

  }

  searchTour() {

    if (this.searchTourObj.TourName) {
      this.searchTourObj.TourName = (this.searchTourObj.TourName).toUpperCase();
    }
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "TourName": this.searchTourObj.TourName,
        "TourType": this.searchTourObj.TourType,
        "Destinations": this.searchTourObj.Destinations,        
        "TourSubType": this.searchTourObj.TourSubType
      }
    };
    this.toursArr = [];
    this.paramTours = {};
    this.searchTourObj = {};
    this.filteredResult = [];
    this.router.navigate(["allTours"], navigationExtras);
  }



  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }

}
